// extracted by mini-css-extract-plugin
export default {"stage":"styles_stage__0nDpm","rotate":"styles_rotate__UU1b7","ring":"styles_ring__-Fa16","poster":"styles_poster__uN4UX"};